import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const RegionPages = {
  list: 'ListRegion',
  add: 'AddRegion',
  edit: 'EditRegion',
}

const { t } = i18n.global

const title = t('pages.listRegion')
const path = '/regions'
const breadcrumb = [{ title, path }]

const regionFormComponent = () => import('@/pages/mainPageWithRoute/region/FormRegion.vue')

const Add: RouteRecordRaw = {
  path: 'add',
  name: RegionPages.add,
  component: regionFormComponent,
  meta: { title: t('actions.add'), requiresAuth: true, breadcrumb },
}

const Edit: RouteRecordRaw = {
  path: ':id',
  name: RegionPages.edit,
  component: regionFormComponent,
  meta: { title: t('actions.edit'), requiresAuth: true, breadcrumb },
}

const List: RouteRecordRaw = {
  path: '',
  name: RegionPages.list,
  component: () => import('@/pages/mainPageWithRoute/region/ListRegionPage.vue'),
  meta: { title, requiresAuth: true },
}

export const Regions: RouteRecordRaw = {
  path,
  name: 'Regions',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title, requiresAuth: true },
  children: [List, Add, Edit],
}
